const r = (e) => e?.replace(/\/$/, "") ?? "", a = (e, t = !1) => {
  const n = new RegExp("^(http|https)://", "i");
  return !e || typeof e != "string" ? "" : n.test(e) ? e : `${t ? "https" : "http"}://${e}`;
}, p = (e, t = !1) => e ? r(a(e, t)) : "", c = (e) => {
  const t = e?.toLowerCase();
  return t === "stg" ? t : t === "prd" ? "www" : "dev";
}, i = () => `https://${c(process.env.ENV || "dev")}.moodys.com`, l = ({
  path: e,
  staticStructure: t
}) => {
  const o = process.env.NODE_ENV === "development" && (process.env.ENV === "dev" || process.env.ENV === "localhost") ? "/dev" : "";
  let s = o;
  return t && (s = `/static${o}/js`), e.length > 0 ? `/${e}${s}` : s;
};
export {
  a,
  c as b,
  l as c,
  i as g,
  r,
  p as s
};
